<p-blockUI [blocked]="blockUiService.isBlocked$ | async">
  <div class="block-ui-wrapper block-ui-main" style="height: 100%">
    <div class="loader"></div>
  </div>
</p-blockUI>

<div
  class="layout-wrapper"
  [ngClass]="{
    'layout-menu-slim': this.ixNgMenuService.slimMenu,
    'layout-menu-overlay': this.ixNgMenuService.overlayMenu,
    'layout-menu-static': this.ixNgMenuService.staticMenu,
    'layout-menu-static-inactive': this.ixNgMenuService.staticMenuInactive,
    'layout-menu-overlay-active': this.ixNgMenuService.overlayMenuActive,
    'layout-menu-active': this.ixNgMenuService.mobileMenuActive,
  }"
>
  <lib-app-topbar #appTopBar></lib-app-topbar>
  <lib-app-topbar-bot></lib-app-topbar-bot>
  <div class="layout-main">
    @if (ixNgComValidationService.appComValidationOpen) {
      <lib-validation-dialog></lib-validation-dialog>
    }
    @if (this.ixNgFavoriteListService.appIxFavoriteListOpen) {
      <ix-favorite-list [defaultHeader]="false"></ix-favorite-list>
    }
    @if (ixNgConfirmationService.appIxConfirmationOpen) {
      <ix-confirmation />
    }

    @if (!this.isDevMode() || (this.isDevMode() && this.appService.prikaziNotification)) {
      <div class="layout-header">
        <div class="layout-obvestila">
          <lib-aktivna-nujna-obvestila
            [aplikacijaOznaka]="this.appService.aplikacijaOznaka"
            class="banner-nujna-obvestila"
            [ngStyle]="{ top: this.ixNgNavigationService.navUp ? '0px' : 'inherit' }"
          ></lib-aktivna-nujna-obvestila>
          <div class="banner-nujna-obvestila-dummy"></div>
        </div>
      </div>
    }

    <div class="layout-main-content">
      <lib-app-menu [reset]="ixNgMenuService.resetSlim"></lib-app-menu>
      <div
        class="layout-content evtMainGovBackground"
        [ngClass]="{ 'layout-content-no-menu': !sideMenuOpen() }"
      >
        <router-outlet></router-outlet>
      </div>
    </div>
    <p-block-ui [blocked]="blockUiService.isBlocked$ | async">
      <div
        class="CssProgressIndicator"
        style="height: 100%; background-image: url('assets/app/gif/load_anim.gif')"
      ></div>
    </p-block-ui>
    <ix-toast></ix-toast>
  </div>
  @if (ixNgMenuService.mobileMenuActive) {
    <div class="layout-mask"></div>
  }
  <lib-app-footer></lib-app-footer>
</div>
<p-confirmDialog #cd icon="fa fa-question-circle">
  <ng-template #footer>
    <p-button
      [label]="cd.confirmation?.acceptLabel || 'Nadaljuj'"
      icon="fa fa-check"
      (onClick)="cd.onAccept()"
    />
    <p-button
      [label]="cd.confirmation?.rejectLabel || 'Prekliči'"
      icon="fa fa-times"
      (onClick)="cd.onReject()"
    />
  </ng-template>
</p-confirmDialog>
